import { FaUser } from "react-icons/fa";
import { ProfileViewMain } from "../Components/ProfileViewMain";

export const ProfileModule = (DATA_USER_AUTH = null) => {

    return [
        {
            views: "PRIVATE", path: "/profile", component: <ProfileViewMain />,
            roles: null, permissions: null, label: "Mi perfil", icon: <FaUser />,
            displayInHeader: false, displayInFooter: false, displayInSidebar: false,
            isBlockedWhenLogged: false
        },

    ]
};
